import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ReactComponent as IconAlert } from "../styles/assets/svg/icon_errored_alert.svg";

// 쿼리 페칭 에러시 나타나는 페이지
export const Fallback: React.FC = () => {
  return (
    <CenteredContainer>
      <ContentTitle>
        <IconAlert width={140} />
        <ErrorMsg>
          <ErrorTitle>Error!</ErrorTitle>

          <ErrorText>{"에러가 발생했습니다."}</ErrorText>
        </ErrorMsg>
      </ContentTitle>
      <Link to="/">
        <StyledButton>메인화면으로 돌아가기</StyledButton>
      </Link>
    </CenteredContainer>
  );
};

// Styled Components
const CenteredContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  padding: 16px;
  background: ${(props) => props.theme.colors.mainBg};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 60px;
`;

const ContentTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 40px;
`;

const ErrorMsg = styled.div`
  display: flex;
  align-iteme: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
`;

const ErrorTitle = styled.h3`
  margin: 0;
  font-size: 2.4rem;
  font-weight: 800;
  text-align: center;
  color: ${(props) => props.theme.colors.primaryActive};
`;

const ErrorText = styled.p`
  font-size: 1.8rem;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  opacity: 0.8;
`;

const StyledButton = styled.button`
  display: flex;
  width: 100%;
  height: 52px;
  padding: 0 24px;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 48px;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  border: none;
  border-radius: 6px;
  align-items: center;
  transition: background-color 0.3s ease;
  gap: 8px;
  cursor: pointer;

  &:hover,
  &:active {
    background-color: ${(props) => props.theme.colors.primaryActive};
  }
`;
